export default class EnvironmentConfiguration {
    static environment = process.env.REACT_APP_NODE_GA_ENV || 'production';
	static isDev = () => EnvironmentConfiguration.environment === 'development';
	static isProd = () => EnvironmentConfiguration.environment === 'production';
}
